import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import { Params } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { decrypt } from '../utils/encryption';
import * as StartActions from '../store/actions/start.actions';
import { Store } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { BusinessTypeEnum } from '../enums/BusinessTypeEnum';
import { CookieConfig } from '../../config/cookie-config';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private cookieService: CookieService,
    private authService: AuthService,
    private store: Store,
    private router: Router,
  ) { }

  afterLogin({token, businessId, businessType, next }) {
    this.cookieService.set(environment.COOKIE_AT, token, CookieConfig.getExpireDate(), '/', environment.COOKIE_DOMAIN, true);
    this.cookieService.set(environment.COOKIE_BID, businessId, CookieConfig.getExpireDate(), '/', environment.COOKIE_DOMAIN, true);
    this.cookieService.set(environment.COOKIE_BT, businessType, CookieConfig.getExpireDate(), '/', environment.COOKIE_DOMAIN, true);
    this.store.dispatch(StartActions.init({ token, businessId, businessType }));
    const commands = [];
    if (next) {
      commands.push(next);
    }
    this.router.navigate(commands, { queryParams: { login: null }, queryParamsHandling: 'merge' });
  }

  loginWithDeprecatedMethod(params: Params) {
    this.store.dispatch(StartActions.cancelInit());
    this.cookieService.deleteAll('/', environment.COOKIE_DOMAIN);

    let loginParsed;

    try {
      loginParsed = JSON.parse(decodeURIComponent(atob(params.login)));
    } catch (e) {
      loginParsed = decrypt(decodeURIComponent(params.login));
    }

    if (loginParsed) {
      if (loginParsed.directToken) {
        this.authService.loginWithDirectToken({direct_login_token: loginParsed.directToken}).subscribe(loginData => {
          this.afterLogin({...this.getApplicationAuthConfig(loginData), next: loginParsed.next});
        });
      } else {
        this.authService.login(loginParsed).subscribe((loginData) => {
          this.afterLogin({...this.getApplicationAuthConfig(loginData)});
        });
      }
    } else {
      this.authService.logout();
    }
  }

  getApplicationAuthConfig(loginData) {
    const authConfig: any = {};
    authConfig.token = loginData.accessToken;
    if (loginData.companyId) {
      authConfig.businessId = loginData.companyId;
      authConfig.businessType = BusinessTypeEnum.Company;
    } else {
      authConfig.businessId = loginData.establishmentId;
      authConfig.businessType = BusinessTypeEnum.Establishment;
    }

    return authConfig;
  }

  canActivate(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    const params = activatedRoute.queryParams;
    const cookieToken = this.cookieService.get(environment.COOKIE_AT);
    const hasLoginParams = 'login' in params;

    if (hasLoginParams) {
      this.loginWithDeprecatedMethod(params);
    }

    return !!cookieToken || hasLoginParams;
  }
}
